import { AppContext } from "AppProvider/AppContext";
import { useContext } from "react";

export const useHasPermission = (permission: string): boolean => {
  const { accountDetails } = useContext(AppContext);

  if (!accountDetails || !Array.isArray(accountDetails.permission)) {
    return false;
  }

  return accountDetails.permission.includes(permission);
};
